import { endpoints } from "@app/api/apis";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { CaretDown, CaretUp } from "@app/sharedComponents/Icons/Icons";
import { useAppSelector } from "@app/store/hooks";
import { Theme, themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import axios from "axios";
import dayjs from "dayjs";
import { CheckCircle } from "@app/sharedComponents/Icons/Icons";
import { useEffect, useState } from "react";
import { ScrollView,Image, ActivityIndicator, Platform, Linking} from "react-native";
import TataLogo from '../../../assets/Icons/TataLogo';
import DSPLogo from '../../../assets/Icons/DSPLogo';
import BajajLogo from '../../../assets/Icons/BajajLogo';
import { LENDER_ID } from "@app/constants/platformPartners";
import Button from "@app/sharedComponents/Button/Button";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import Sechedule_icon from '../../../assets/Icons/Sechedule_icon';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
const advancedFormat = require('dayjs/plugin/advancedFormat');
dayjs.extend(advancedFormat);
let RNFetchBlob: any;
if (Platform.OS === "android") {
    RNFetchBlob = require('rn-fetch-blob')

}
import ContactUs from "../UserProfile/ContactUs";
import { useTheme } from "@shopify/restyle";

const logoObj = (colors) => ({
    tata: <TataLogo/>,
    bajaj: <Image source={{
        uri:"data:image/png;base64,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"
    }} style={{width: 156, height: 14}}
    // resizeMode="contain"
    />,
    dsp: <DSPLogo color1={colors}/>,
})

interface RepaymentScheduleDetails {
  repaymentScheduleName?: string;
  generatedTimestamp?: string;
  repaymentScheduleLink?: string;
}

const MyLoanDetails = ({navigation, route}: {navigation: any, route: any}) =>{
    const loanData = useAppSelector(state => state.auth.loanDetails);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const lendingPartnerId = userDetails?.linkedCredits[0]?.lendingPartnerId;
    const isLendingPartnerTata = lendingPartnerId?.toLowerCase() === LENDER_ID.TATA.toLowerCase();
    const [showInterestDetails,setShowInteresDetails] = useState(true);
    const [showLoanDetails,setShowLoanDetails] = useState(true);
    const [showRepaymentDetails,setShowRepaymentDetails] = useState(true);
    const [downloadText,setDownloadText] =useState('Generate')
    const [showLoader,setShowLoader] = useState(false);
    const [buttonLoader,setButtonLoader] = useState(false);
    const [showRepaymentSecheduleCard,setShowRepaymentSecheduleCard] = useState(false);
    const [repaymentSecheduleDetails,setRepaymentSecheduleDetails] = useState<RepaymentScheduleDetails>({});
    const [showErrorCard,setShowErrorCard] = useState(false);
    const [errorDate,setErrorData] = useState({});
    const firebaseParams = useAppSelector((state) => state.firebaseParams);
    const {colors} = useTheme<Theme>();
    const showRepaymentSchedule = firebaseParams?.show_repayment_schedule_tata === 'true' || firebaseParams?.show_repayment_schedule_tata_test_numbers?.includes(userDetails?.user?.phoneNumber);
    
    const {loanDetails,interestDetails} = loanData;
    const logo = (id) => {
        console.log('logo',id)
        return logoObj(colors['icon-primary'])[id]
    }

    const  handleRepaymentSchedule = () => {
        if(showLoader) return;
        setDownloadText('Generating...');
        setShowLoader(true);
        const url = endpoints?.repaymentSchedule + userDetails?.linkedCredits[0]?.creditId;
        axios.get(url)
        .then(res => {
           setShowRepaymentSecheduleCard(true);
           setRepaymentSecheduleDetails(res?.data);
        })
        .catch(err => {
            setShowErrorCard(true);
            setErrorData(err?.data)
            console.log('otp error',err);
        }).finally(()=>{
            setShowLoader(false);
            setDownloadText('Generate');
        })
        
    }

    const handleRepaymentDownload = async () => {
        setButtonLoader(true);
        const downloadUrl = repaymentSecheduleDetails?.repaymentScheduleLink;
        const fileName = repaymentSecheduleDetails?.repaymentScheduleName;
        if (Platform.OS !== "web") {
            if(Platform.OS === "ios" && downloadUrl) {
                Linking.openURL(downloadUrl)
                setButtonLoader(false);
            } 
            else if(downloadUrl) {
            try {
                const RNFetchObject = RNFetchBlob.default
                const fs = RNFetchObject.fs;
    
                const downloadsDir = fs.dirs.DownloadDir;
                await RNFetchObject.config({
                    fileCache: true,
                    addAndroidDownloads: {
                        useDownloadManager: true,
                        notification: true,
                        path: `${downloadsDir}/${fileName}`,
                        description: 'Downloading file...',
                    },
                }).fetch('GET', downloadUrl);
                } catch (error) {
                    console.log('error',error);
                    setButtonLoader(false);
                    setShowRepaymentSecheduleCard(false);
                } finally {
                    setButtonLoader(false);
                    setShowRepaymentSecheduleCard(false);
                }
            }
        }
        else {
            if(downloadUrl){
            fetch(downloadUrl)
                .then((response) => response.blob())
                .then((blob) => {
    
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${fileName}`;
                    document.body.appendChild(a);
                    a.click();
                    URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                    
                })
                .catch((error) => {
                    setButtonLoader(false);
                    setShowRepaymentSecheduleCard(false);
                    console.warn('Error download file: ', error);
                }).finally(()=>{
                    setButtonLoader(false); 
                    setShowRepaymentSecheduleCard(false);
                }); 
            }
        }

    }


    return(
        <>
        <PageHeaders label="My loan details" pageName={route?.name} navigation={navigation} />
        <ScrollView style={{flex:1,backgroundColor:themeColorSet["bg-surface-primary"]}}>
            <ThemedView p="md" borderWidth={1} borderColor="border-primary" borderRadius="md" backgroundColor="bg-fill-primary" m="lg">
                <ThemedText variant="b4r" color="text-secondary" mb="xs">Total credit limit</ThemedText>
                <ThemedView flexDirection="row" alignItems="center">
                <ThemedText variant="l2" color="text-emphasis-secondary" mb="xs">₹</ThemedText>
                <ThemedText variant="h2b" color="text-emphasis-secondary" mb="xs">{formatIndianCurrency(loanDetails?.actualLoanAmount)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-primary" my="md" />
                <ThemedText variant="b4r" color="text-secondary" mb="xs">Pledged funds value</ThemedText>
                <ThemedText variant="b2b" color="text-primary" mb="xs">₹{formatIndianCurrency(loanDetails?.totalValueOfAssetsPledged)}</ThemedText>
            </ThemedView>
            <ThemedPressable justifyContent="space-between" flexDirection="row" alignItems="center"  mx="lg" onPress={()=>{setShowInteresDetails(!showInterestDetails)}}>
                <ThemedText color="text-primary" variant="b3s">Interest details</ThemedText>
                {showInterestDetails ? <CaretUp color={colors['icon-primary']}/> : <CaretDown color={colors['icon-primary']}/>}
            </ThemedPressable>
            {showInterestDetails &&
            <ThemedView p="md" borderWidth={1} borderColor="border-primary" borderRadius="md" backgroundColor="bg-fill-primary" m="lg">
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Interest rate</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{interestDetails?.interestRate}%</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xs">
                    <ThemedText variant="b4r" color="text-primary">Un-billed interest</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">₹{interestDetails?.unBilledInterest}</ThemedText>
                </ThemedView>
                <ThemedText variant="b5r" color="text-secondary">from {dayjs(interestDetails?.unBilledInterestStartDate).format('DD MMM')} to {dayjs(interestDetails?.unBilledInterestEndDate).format('DD MMM')}</ThemedText>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xs">
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant="b4r" color="text-primary">Estimated interest </ThemedText>
                        <ThemedText variant="b5r" color="text-secondary">@ ₹{interestDetails?.interestPerDay} per day</ThemedText>
                    </ThemedView>

                    <ThemedText variant="b4m" color="text-primary">₹{formatIndianCurrency(interestDetails?.estimatedInterest)}</ThemedText>
                </ThemedView>
                <ThemedText variant="b5r" color="text-secondary">until {dayjs(interestDetails?.estimatedInterestEndDate).format('Do MMM')}</ThemedText>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />

                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Next interest due date</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{dayjs(interestDetails?.nextInterestDueDate).format('DD MMM YYYY')}</ThemedText>
                </ThemedView>
                {interestDetails?.mandateSetup && <>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Next autopay on</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{dayjs(interestDetails?.nextAutoPayDate).format('DD MMM YYYY')}</ThemedText>
                </ThemedView>
                <ThemedView backgroundColor="bg-fill-emphasis-secondary"  mt="md" borderRadius="sm" alignItems="center" flexDirection="row" flex={1} flexWrap="wrap" px="md" py="sm"  >
                    <CheckCircle size={14} weight="fill" color={themeColorSet["icon-success"]}/>
                    <ThemedText ml="sm" variant="b4r" color="text-emphasis-secondary">Autopay is active </ThemedText>
                </ThemedView>
                </>
                }
            </ThemedView>}
            <ThemedView height={1} backgroundColor="border-secondary" my="md" />

            <ThemedPressable onPress={()=>{setShowLoanDetails(!showLoanDetails)}} justifyContent="space-between" flexDirection="row" alignItems="center"  mx="lg">
                <ThemedText color="text-primary" variant="b3s">Loan details</ThemedText>
                {showLoanDetails ? <CaretUp color={colors['icon-primary']}/> : <CaretDown color={colors['icon-primary']}/>}
            </ThemedPressable>
            {showLoanDetails && 
            <ThemedView p="md" borderWidth={1} borderColor="border-primary" borderRadius="md" backgroundColor="bg-fill-primary" m="lg">
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Lending partner</ThemedText>
                    {logo(loanDetails?.lendingPartnerId?.toLowerCase())}
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Approved limit</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">₹{formatIndianCurrency(loanDetails?.actualLoanAmount)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Utilised limit</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">₹{formatIndianCurrency(loanDetails?.principalOutStandingAmount)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Available limit</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">₹{formatIndianCurrency(loanDetails?.availableCreditAmount)}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Tenure</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{loanDetails?.tenureInMonths} months</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Remaining tenure</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{loanDetails?.remainingTenureInDays} days</ThemedText>
                </ThemedView>
                <ThemedText variant="b5r" color="text-secondary">Expiry on {dayjs(loanDetails?.expiryDate).format('DD MMM YYYY')}</ThemedText>

                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">A/C opening date</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{dayjs(loanDetails?.currentTermStartDate).format('DD MMM YYYY')}</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Loan type</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">{loanDetails?.loanType}</ThemedText>
                </ThemedView>
                
            </ThemedView>}
            {isLendingPartnerTata && showRepaymentSchedule && <ThemedPressable style={{marginBottom:showRepaymentDetails ? 0 : 16}} justifyContent="space-between" flexDirection="row" alignItems="center"  mx="lg" mt="lg" onPress={()=>{setShowRepaymentDetails(!showRepaymentDetails)}}>
                <ThemedText color="text-primary" variant="b3s">Repayment details</ThemedText>
                {showRepaymentDetails ? <CaretUp/> : <CaretDown/>}
            </ThemedPressable>}
            {isLendingPartnerTata && showRepaymentSchedule && showRepaymentDetails &&
            <ThemedView p="md" borderWidth={1} borderColor="border-primary" borderRadius="md" backgroundColor="bg-surface-primary" m="lg">
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Interest repayment</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">Monthly</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Principal repayment</ThemedText>
                    <ThemedText variant="b4m" color="text-primary">Flexible</ThemedText>
                </ThemedView>
                <ThemedView height={1} backgroundColor="border-secondary" my="md" />
                <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ThemedText variant="b4r" color="text-primary">Repayment schedule</ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        {showLoader && <ActivityIndicator color={themeColorSet['text-action-primary']} size={'small'} style={{marginRight:8}}/>}
                        <ThemedText variant="b3b" color="text-action-primary" onPress={handleRepaymentSchedule}>{downloadText}</ThemedText>
                    </ThemedView>    
                </ThemedView>
            </ThemedView>
            }
            <BottomSheetContainer
                isVisible={showRepaymentSecheduleCard}
                close={()=>setShowRepaymentSecheduleCard(false)}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                onClose={undefined} 
                dragComponent={undefined} 
                containerStyle={undefined}>
            <ThemedView p='lg' mt='md'>
                <ThemedText variant='h5s' color='text-primary'>Repayment schedule</ThemedText>
                <ThemedView my='xl' borderWidth={1} borderColor='border-primary' borderRadius='md' p='md' flexDirection='row' alignItems='center'>
                    <Sechedule_icon/>
                    <ThemedView ml='md'>
                        <ThemedText variant='b3m' color='text-primary'>{repaymentSecheduleDetails?.repaymentScheduleName}</ThemedText>
                        <ThemedText variant='b4r' color='text-secondary'>Generated on {dayjs(repaymentSecheduleDetails?.generatedTimestamp).format('DD MMM YY')}</ThemedText>
                    </ThemedView>
                </ThemedView>
                <Button
                    label={'Download'}
                    type={'SOLID'}
                    buttonLoader={buttonLoader}
                    handlePress={handleRepaymentDownload}
                    size='MD'
                />
            </ThemedView>
            </BottomSheetContainer>
            <BottomSheetContainer
                isVisible={showErrorCard}
                close={()=>setShowErrorCard(false)}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                onClose={undefined} 
                dragComponent={undefined} 
                containerStyle={undefined}>
                    <ThemedView alignItems='center' justifyContent='center' p="lg">
                        <WarningCircle size="48"  weight="fill"  fill={themeColorSet['icon-error']} />
                        <ThemedText mt="lg" variant='h5s' color='text-primary'>{errorDate?.header || 'Verification failed!'}</ThemedText>
                        <ThemedView mt="sm" mb="xl" backgroundColor='bg-fill-info' p="sm" borderRadius='sm' width={'100%'}>
                            <ThemedText textAlign='center' color='text-secondary' variant='b3r'>
                            {errorDate?.message || 'Something went wrong. Please try again later.'}
                            </ThemedText>
                        </ThemedView>
                        <Button
                            label={'Try again'}
                            type='SOLID'
                            handlePress={()=>setShowErrorCard(false)}
                            overRideStyle={{marginBottom: 12}}
                        />
                </ThemedView>
            </BottomSheetContainer>
        </ScrollView>
        </>
    )
}

export default MyLoanDetails;